
export class DetectMobileView {
    
    static detectScreenSize(): boolean {
        return window.innerWidth <= 576;
    }

    static isScreenSizeTabletOrSmaller(): boolean {
        return window.innerWidth <= 768;
    }

    static isScreenSizeTablet(): boolean {
        return window.innerWidth <= 768 && window.innerWidth > 576;
    }
}